const mod11Verifier = (id: string, idVerifier = ''): boolean => {
  const n: string = id.replace(/\D/g, '');

  const reversedStringArray = Array.from(n.toString()).reverse();
  const sum = reversedStringArray.reduce((memo, digit, index) => {
    const factor = (index % 6) + 2;
    return memo + parseInt(digit, 10) * factor;
  }, 0);

  const mod11 = 11 - (sum % 11);
  let verifier: number | string = mod11;
  if (mod11 === 11) {
    verifier = 0;
  }
  if (mod11 === 10) {
    verifier = 'k';
  }
  return verifier.toString() === idVerifier.toLocaleLowerCase();
};

export { mod11Verifier };
